import { Api } from "./fetchFromApi";

export async function getVoices() {
  try {
    const response = await Api.get("/api/quests/aitours/listAllVoices");
    return response;
  } catch (error) {
    console.error("Error fetching voices:", error);
    return [];
  }
}
